import { render, staticRenderFns } from "./bindMf.vue?vue&type=template&id=15c5c004&scoped=true&"
import script from "./bindMf.vue?vue&type=script&lang=js&"
export * from "./bindMf.vue?vue&type=script&lang=js&"
import style0 from "./bindMf.vue?vue&type=style&index=0&id=15c5c004&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5c004",
  null
  
)

export default component.exports